export default "__VITE_ASSET__NfV8MbAz__"